import { useRefereeEligibilities } from '../hooks/useRefereeEligibilities';
import { Fragment } from 'react/jsx-runtime';
import { Judge, RecentLevelParaEnum } from '~/apis/ssf';

interface Props {
  referee: Pick<Judge, 'is_non_para' | 'is_para'> & {
    recent_level: RecentLevelParaEnum | null;
    recent_level_para: RecentLevelParaEnum | null;
  };
}

export function RefereeEligibilities({ referee }: Props) {
  const eligibilities = useRefereeEligibilities(referee);

  return <Fragment>{eligibilities.length > 0 ? eligibilities.join(', ') : '-'}</Fragment>;
}
